<script>
const sidebarMenu = [
  {
    path: '/home',
    icon: 'fa fa-th',
    title: '工作台',
    children: [
      {
        path: '/home/dashboard',
        title: '首页',
      },
    ],
  },
  {
    path: '/goods',
    icon: 'fa fa-th',
    title: '商品管理',
    children: [
      {
        path: '/goods/list',
        title: '商品列表',
      },
      {
        path: '/goods/type',
        title: '商品类型',
      },
      {
        path: '/goods/category',
        title: '商品目录',
      },
      {
        path: '/goods/collection',
        title: '商品集合',
      },
      {
        path: '/goods/brand',
        title: '商品品牌',
      },
    ],
  },
  {
    path: '/marketing',
    icon: 'fa fa-th',
    title: '营销管理',
    children: [
      {
        path: '/marketing/ad',
        title: '广告管理',
      },
      {
        path: '/marketing/activity',
        title: '活动管理',
      },
      {
        path: '/marketing/groupbuy',
        title: '团购管理',
      },
      {
        path: '/marketing/lottery',
        title: '抽奖管理',
      },
      {
        path: '/marketing/notices',
        title: '通告管理',
      },
      {
        path: '/marketing/commission',
        title: '分销佣金',
      },
      {
        path: '/marketing/rechargecard',
        title: '充值卡',
      },
    ],
  },
  {
    path: '/orders',
    icon: 'fa fa-th',
    title: '订单管理',
    children: [
      {
        path: '/orders/list',
        title: '订单列表',
      },
      {
        path: '/orders/comments',
        title: '订单商品评价',
      },
      {
        path: '/orders/listreservation',
        title: '预约和报告管理',
      },
      {
        path: '/orders/listsalerservice',
        title: '售后退款',
      },
    ],
  },
  {
    path: '/members',
    icon: 'fa fa-th',
    title: '会员管理',
    children: [
      {
        path: '/members/list',
        title: '会员列表',
      },
      {
        path: '/members/funds',
        title: '资金管理',
      },
    ],
  },
  {
    path: '/articals',
    icon: 'fa fa-th',
    title: '文章管理',
    children: [
      {
        path: '/articals/category',
        title: '文章目录',
      },
      {
        path: '/articals/list',
        title: '文章列表',
      },
      {
        path: '/articals/edit',
        title: '添加文章',
      },
    ],
  },
  {
    path: '/rbac',
    icon: 'fa fa-key',
    title: '权限管理',
    children: [
      {
        path: '/system/rbac/role',
        title: '角色管理',
      },
      { path: '/system/rbac/permission', title: '权限管理' },
      { path: '/system/rbac/user', title: '用户管理' },
    ],
  },
  {
    path: '/config',
    icon: 'fa fa-cogs',
    title: '系统管理',
    children: [
      {
        path: '/config/emshop',
        title: '商城设置',
      },

      {
        path: '/config/payment',
        title: '账号配置',
      },
      {
        path: '/config/expresscorp',
        title: '快递公司',
      },
      {
        path: '/config/aboutus',
        title: '关于我们',
      },
    ],
  },
]

export default sidebarMenu
</script>
